(function () {
  if (window.umDiaHeaderReady) return;
  window.umDiaHeaderReady = true;
  function closeMenu(nav, restoreFocus) {
    nav.classList.remove('is-menu-open');
    var button = nav.querySelector('[data-ud-menu-toggle]');
    if (button) { button.setAttribute('aria-expanded', 'false'); if (restoreFocus) button.focus(); }
  }
  function update() {
    document.querySelectorAll('[data-ud-overlay-nav]').forEach(function (nav) {
      nav.classList.toggle('is-scrolled', nav.hasAttribute('data-ud-solid-nav') || window.scrollY > 24);
      var page = nav.closest('.ud-page');
      if (page) page.style.setProperty('--ud-nav-height', (nav.offsetHeight + 16) + 'px');
    });
  }
  var pending = false;
  window.addEventListener('scroll', function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { update(); pending = false; });
  }, {passive: true});
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1200) document.querySelectorAll('[data-ud-overlay-nav]').forEach(function (nav) { closeMenu(nav, false); });
    update();
  });
  window.addEventListener('pageshow', update);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ud-menu-toggle]');
    if (toggle) {
      var nav = toggle.closest('[data-ud-overlay-nav]');
      if (!nav) return;
      var open = toggle.getAttribute('aria-expanded') !== 'true';
      nav.classList.toggle('is-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      return;
    }
    var link = event.target.closest('.ud-nav__links a');
    if (link) closeMenu(link.closest('.ud-nav'), false);
    var playback = event.target.closest('[data-ud-hero-playback]');
    if (playback) {
      var video = playback.closest('.ud-hero__visual').querySelector('video');
      if (!video) return;
      if (video.paused) { var promise = video.play(); if (promise) promise.catch(function () {}); }
      else video.pause();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('[data-ud-overlay-nav].is-menu-open').forEach(function (nav) { closeMenu(nav, true); });
  });
  function syncPlayback(event) {
    if (!event.target.matches('.ud-hero__video')) return;
    var button = event.target.parentElement.querySelector('[data-ud-hero-playback]');
    if (!button) return;
    button.setAttribute('aria-label', event.target.paused ? 'Reproduzir vídeo' : 'Pausar vídeo');
    button.firstElementChild.textContent = event.target.paused ? '▶' : 'Ⅱ';
  }
  document.addEventListener('play', syncPlayback, true);
  document.addEventListener('pause', syncPlayback, true);
  update();
})();
